/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {

	export enum UserMessageType {Success, Error, Warning, Information, Variation}

}